import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import { Container } from "../../Utils/Container/Container";
import TranslaterContentHeader from "../../components/TranslaterContentHeader/TranslaterContentHeader";
import AccordionButton from "../../components/AccordionButton/AccordionButton";
import DataViewerTwoColoms from "../../components/DataViewerTwoColoms/DataViewerTwoColoms";
import ActionButton from "../../components/ActionButton/ActionButton";

import anfrage from "../../assets/anfrage-tranlsater.svg";
import euroIcon from "../../assets/cardIcons/euro-sign-svgrepo-com.svg";
import adresseIcon from "../../assets/adresse-icon.svg";
import qualification from "../../assets/qualification-translater.svg";
import info from "../../assets/info-translater.svg";
import "./style.css";

//? Temporay data
const tranlsatorQalification = [
	{
		infoKey: "Sprache I",
		infoValue: "Englisch"
	},
	{
		infoKey: "Sprache II",
		infoValue: "Ukrainisch"
	},
	{
		infoKey: "Sprache III",
		infoValue: "Jiddisch"
	},
	{
		infoKey: "IHK Prüfung",
		infoValue: "Ja"
	},
	{
		infoKey: "Beeidigung",
		infoValue: "Ja"
	},
	{
		infoKey: "Sprachshpezifisches Studium",
		infoValue: "Nein"
	},
	{
		infoKey: "Aufbauschulung",
		infoValue: "Ja"
	},
	{
		infoKey: "Simultandolmetschen",
		infoValue: "Ja"
	},
	{
		infoKey: "Konferenzdolmetschen",
		infoValue: "Nein"
	},
	{
		infoKey: "Psychologisches Training",
		infoValue: "Nein"
	}
];
const translatorInformation = [
	{
		infoKey: "Name / Vorname",
		infoValue: "MUSTERMANN ANNALIZA"
	},
	{
		infoKey: "Geschlecht",
		infoValue: "Weiblich"
	},
	{
		infoKey: "Geburtsdatum",
		infoValue: "XX / XX / XXXX"
	},
	{
		infoKey: "Geburtsort",
		infoValue: "München"
	},
	{
		infoKey: "Geburtsland",
		infoValue: "Deutschland"
	},
	{
		infoKey: "Staatsangehörigkeit",
		infoValue: "Deutsch"
	},
	{
		infoKey: "Aufenthaltstatus",
		infoValue: "Deutsch"
	},
	{
		infoKey: "Ausweisdokument",
		infoValue: "Reisepass"
	},
	{
		infoKey: "Gültig bis",
		infoValue: "XX / XX / XXXX"
	},
];
const contactInformation = [
	{
		infoKey: "Straße",
		infoValue: "Regerstraße"
	},
	{
		infoKey: "Hausnummer",
		infoValue: "XX"
	},
	{
		infoKey: "Postleitzahl",
		infoValue: "XXXXX"
	},
	{
		infoKey: "Ort",
		infoValue: "München"
	},
	{
		infoKey: "Telefon I",
		infoValue: "+49-171-XXX-XXX"
	},
	{
		infoKey: "Telefon II",
		infoValue: "+49-89-XXX-XXX"
	},
	{
		infoKey: "E-Mail",
		infoValue: "mustermann@web.de"
	}
];
const paymentInformation = [
	{
		infoKey: "Stundenhonorar",
		infoValue: "Regerstraße"
	},
	{
		infoKey: "Zeilenhonorar",
		infoValue: "22b"
	},
	{
		infoKey: "IBAN",
		infoValue: "DEXX XXXX XXXX XXXX XXXX XX"
	},
	{
		infoKey: "USt pflichtig",
		infoValue: "Ja"
	},
	{
		infoKey: "USt pflichtig seit/ab",
		infoValue: "XX / XX / XXXX"
	},
]

const TranslaterPage = () => {
	const navigate = useNavigate();

	const handleAnrufenClick = () => {
		navigate('/report');
	};

	return (
		<Container>
			<Header />
			<div className="translater-top">
				<div className="translater-top__left">
					<img src={anfrage} alt="Anfrage" />
					<p>Anfrage # 000 000 000 </p>
				</div>
				<div className="translater-top__right">
					<span className="einsatzleiter-label">Einsatzleiter:</span>
					<span className="einsatzleiter-name">POM Max Mustermann</span>
				</div>
			</div>

			<div className="translater-content">

				<div className="translater-qulification">
					<TranslaterContentHeader background="#559d62" text="SPRACHEN / Qualificationen" icon={qualification} />
					<div className="translater-qulification__content">
						<DataViewerTwoColoms data={tranlsatorQalification} />
					</div>
				</div>

				<div className="translater-information__wrapper">
					<div className="translater-information">
						<TranslaterContentHeader background="#E38126" text="ALGEMEINE INFORMATIONEN" icon={info} />
						<div className="translater-information__content-wrapper">
							<div className="translater-information__imageContent">
								<img src="https://images.pexels.com/photos/3727474/pexels-photo-3727474.jpeg?cs=srgb&dl=pexels-shvetsa-3727474.jpg&fm=jpg" alt="Translator" />
								<p>Dolmetscher Bewertung</p>
								<div className="rating-container">
									<div className="rating-star"></div>
									<div className="rating-star"></div>
									<div className="rating-star"></div>
									<div className="rating-star"></div>
									<div className="rating-star"></div>
								</div>
								<p>Bewertungen ansehen</p>
							</div>
							<div className="translater-information__content">
								<DataViewerTwoColoms data={translatorInformation} />
							</div>
						</div>
					</div>
					<div className="translator-additionalInformation">
						<div></div>
						<div>
							<div className="translator-additionalInformation_info-buttons">
								<AccordionButton title="ADRESSE /KONTAKTDATEN" background="#16869a" icon={adresseIcon} data={contactInformation} />
								<AccordionButton title="ZAHLUNGSDATEN" background="#8c5e95" icon={euroIcon} data={paymentInformation} />
							</div>
							<div className="translator-additionalInformation_action-buttons">
								<div>
									<ActionButton textColor="#fff" background="#D12927" text="Einsatz stornieren" />
									<ActionButton textColor="#000" background="#0BE2FF" text="Einsatz starten" onClick={handleAnrufenClick} />
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</Container>
	)
}

export default TranslaterPage;
